export const formatDateTooltip = (params) => {
  return params.value;
};